import { Box, IconButton, Tooltip } from "@mui/material";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";

const ReplaceMainUserButton = ({
  handleReplaceUser,
}: {
  handleReplaceUser: () => void;
}) => {
  return (
    <Box>
      <Tooltip title="Replace main user">
        <IconButton
          onClick={() => handleReplaceUser()}
          sx={{ padding: 0 }}
          aria-label="replace-user"
          size="large"
        >
          <ManageAccountsIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default ReplaceMainUserButton;
